
import { Component, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from "@angular/cdk/clipboard"


@Component({
    selector: 'citation-modal',
    templateUrl: './citation-modal.html'
  })
  export class CitationModal {
    @Input() bibEntry;
    copy_button_label:string;
  
    constructor(public activeModal: NgbActiveModal, private clipboard:Clipboard) {
      this.copy_button_label="Copy to Clipboard";
    }
    copy(){
      let that = this;
      this.clipboard.copy(this.bibEntry);
      
    }
  }

  